import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, CircleCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { DEMO_URL } from '../data/links';
const BACKGROUND_URL = 'https://cdn.magicpatterns.com/uploads/aXEut9pPsotAxhP8gwVBhT/Problem_section.png';
const APP_SCREEN_URL = 'https://cdn.magicpatterns.com/uploads/atmbrg3gex4H6bb2ksgvTC/Column.png';
export function FinalCta() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="final-cta-title" className="px-4 pb-16 sm:px-6 lg:pb-24" data-id="element-62" data-mp="1ee1wk4qznxwf">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.25
    }} transition={{
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative isolate mx-auto max-w-[1140px] overflow-hidden rounded-[24px] bg-[#03043A] [transform:translateZ(0)] sm:rounded-[32px]" data-id="element-63" data-mp="1ec7lrj9flm62">
        <img src={BACKGROUND_URL} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover" data-id="element-64" data-mp="1x64invmeg6e2" />

        <div className="relative px-5 pt-14 text-center sm:px-10 sm:pt-20 lg:pt-24" data-id="element-65" data-mp="s5gw02f9onlc">
          <h2 id="final-cta-title" className="font-hero text-[32px] font-medium leading-[1.15] tracking-[-0.01em] text-white sm:text-[42px] lg:text-[48px]" data-id="element-66" data-mp="x3io1cuo7x8y">
            {t.finalCta.titleBefore}{' '}
            <span className="relative inline-block text-[#F8A400]" data-id="element-67" data-mp="1646v1nlncxcc">
              <span aria-hidden="true" className="absolute -inset-x-[0.14em] inset-y-[0.06em] rounded-[0.05em]" style={{
              background: 'linear-gradient(90deg, rgba(248,164,0,0.22) 0%, rgba(248,164,0,0.14) 50%, rgba(248,164,0,0.02) 92%, rgba(248,164,0,0) 100%)'
            }} data-id="element-68" data-mp="1b2i4vybxz7uk" />
              <span className="relative" data-id="element-69" data-mp="1ttjdle2v6hrb">{t.finalCta.highlight}</span>
            </span>{' '}
            {t.finalCta.titleAfter}
          </h2>

          <p className="mx-auto mt-5 max-w-[400px] text-[15px] leading-[1.6] text-white/85 sm:text-base" data-id="element-70" data-mp="3qux9olbbrwzj">
            {t.finalCta.subtitle}
          </p>

          <div className="mt-8 flex flex-col items-center gap-3" data-id="element-71" data-mp="3i4r0y4wvkve">
            <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 rounded-xl bg-[#E8A33A] py-2 pl-5 pr-2 text-base font-semibold text-blue-reways-950-lock shadow-[0_8px_24px_rgba(248,164,0,0.25)] transition-colors hover:bg-[#F2B04A] focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-72" data-mp="3jfuewug2qlz">
              {t.cta.demo}
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/35" data-id="element-73" data-mp="ifx29e3fdn3s">
                <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="2o8ve77v8xf24" />
              </span>
            </a>
            <p className="flex items-center gap-1.5 text-[13px] text-white/55" data-id="element-75" data-mp="2k7a39s29vauk">
              <CircleCheck className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" data-mp="2a21uxwqhsc4p" />
              {t.finalCta.note}
            </p>
          </div>

          <img src={APP_SCREEN_URL} alt={t.showcase.previewAlt} loading="lazy" className="mx-auto mt-10 block w-full max-w-[860px] sm:mt-12" data-id="element-77" data-mp="2e3dqeiw1rrkt" />
        </div>
      </motion.div>
    </section>;
}